import { Component, EventEmitter, Input, Output } from "@angular/core";


@Component({
    selector: "warning-dialog",
    template: `
            <p-dialog [(visible)]="visible"
                [closable]="false"
                [style]="{'max-width': '470px', width: '100%'}"
                styleClass="warning-dialog"
                [header]="headerText"
                [modal]="true"
                [draggable]="false">
                <ng-template pTemplate="header">
                    <div class="p-dialog-title" >
                        <span >
                            <i [class]="iconClass" aria-hidden="true"></i>
                            {{headerText}}
                        </span>
                    </div>
                </ng-template>
                <p class="text-center mt-2">
                     {{text}}
                </p>
            <div class ="flex justify-content-end">
                <button pButton
                    class="m-button-primary mb-1"
                    type="button"
                    label="OK"
                    (click)="close()"
                    allowOffline>
                </button>
            </div>
        </p-dialog> 
    `,

    styles: [
        `:host ::ng-deep {
            .warning-dialog {
                .p-dialog-header {
                    font-weight: bold;
                    color: rgb(240, 188, 109);
                    background-color: rgb(254, 252, 249);
                    .p-dialog-title {
                    }
                }
            }
        }
        `
    ]

    })

export class WarningDialogComponent {
    @Input() text: string;
    @Output() readonly closed = new EventEmitter();

    visible = true;
    @Input() headerText = "Warning";  
    @Input() iconClass = "pi pi-exclamation-triangle mr-1"; 
   
    close() {
        this.visible = false;
        this.closed?.emit();
    }
    constructor() {}
    
}
